import Vue from 'vue/dist/vue.esm';
import Store from './store/Store'
import AppActions from './components/AppActions.vue';
import AppFilter from './components/AppFilter.vue';

import { Hamburger } from './functions/Hamburger';
import { ScrollToId } from './functions/ScrollToId';
import { PlayButton } from './functions/PlayButton';
import { ScrollToHeightDown } from './functions/ScrollToHeightDown';
import { ReferenceCollapse } from './functions/ReferenceCollapse';
import { SectionParallax } from './functions/SectionParallax.js'
import { Filter } from './functions/Filter';
import { Gallery } from './functions/Gallery';
import { ReviewsCarousel } from './functions/ReviewsCarousel';
import { FilterCardCollapse } from './functions/FilterCardCollapse';
import { Modal, Collapse } from 'bootstrap/dist/js/bootstrap.esm';

new Vue({
  el: '#app',
  store: Store,
  components: {
    AppActions,
    AppFilter,
  },
  mounted () {
    document.documentElement.classList.remove('no-js');
    document.documentElement.classList.add('js');

    Filter();
    FilterCardCollapse();
    Gallery();
    Hamburger();
    PlayButton();
    ReferenceCollapse();
    ReviewsCarousel();
    ScrollToHeightDown();
    ScrollToId();
  }
});

window.addEventListener('load', function () {
  SectionParallax();
})


class CookieOps {
  static create(name, value, days) {
    let expires;
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toGMTString();
    } else expires = "";
    document.cookie = `${name}=${value}${expires}; path=/`;
  }

  static read(name) {
    const nameEQ = `${name}=`;
    return document.cookie.split(';')
      .map(c => c.trim())
      .find(c => c.indexOf(nameEQ) === 0)
      ?.substring(nameEQ.length);
  }
}

class EventListeners {
  static load() {
    window.addEventListener('load', function () {
      const checkModal = document.getElementById('applicationModal');

      if (!checkModal || CookieOps.read('hideModal')) {
        return;
      }

      const registrationModal = new Modal(checkModal);
      registrationModal.show();

      const modalBtn = document.querySelector('.js-registration');

      if (modalBtn) {
        modalBtn.addEventListener('click', function () {
          registrationModal.hide();
          const hideForDays = parseInt(checkModal.getAttribute('data-hide-for-days'), 10);
          if (!isNaN(hideForDays)) {
            CookieOps.create('hideModal', true, hideForDays);
          }

          setTimeout(function() {
            const id = location.hash.slice(1);
            const element = document.getElementById(id);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }, 500);
        });
      }
    });
  }

  static hashchange() {
    window.addEventListener("hashchange", function () {
      const id = location.hash.slice(1),
            element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
}


EventListeners.load();
EventListeners.hashchange();
